<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><i></i> </p>
<p class="p5"><i>For the Members of the Aardvarks,</i><span class="Apple-converted-space"> </span></p>
<p class="p5"><i>the oldest established SF-writing workshop</i><span class="Apple-converted-space"> </span></p>
<p class="p5"><i>in Minneapolis and/or St. Paul</i><span class="Apple-converted-space"> </span></p>
<p class="p3"><i></i> </p>
<p class="p5"><i>(We also do mysteries</i><span class="Apple-converted-space"> </span></p>
<p class="p5"><i>and doctoral dissertations.)</i></p>
<p class="p4"><b></b> </p>
<p class="p3"><b></b> </p>
<p class="p3"><b></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?5bf7d5fb